import React from 'react';
import dayjs from 'dayjs';
import FieldDisplay from './FieldDisplay';
import HeaderSection from './HeaderSection';

const InfoSection: React.FC<{ data: any }> = ({ data }) => (
    <>
        <HeaderSection title="Info" />
        <div className="p-6 pt-0">
            <div className="grid grid-cols-2 gap-4">
                <FieldDisplay
                    label="Created By"
                    value={data?.createdBy || '-'}
                    className="mb-0"
                    hasBorder={false}
                />
                <FieldDisplay
                    label="Created Date"
                    value={
                        data?.createdAt
                            ? dayjs(data.createdAt).format('MMMM D, YYYY [at] HH.mm')
                            : '-'
                    }
                    className="mb-0"
                    hasBorder={false}
                />
            </div>
            <div className="border-t border-gray-200 mt-2 mb-4" />
            <div className="grid grid-cols-2 gap-4">
                <FieldDisplay
                    label="Last Updated By"
                    value={data?.updatedBy || '-'}
                    hasBorder={false}
                />
                <FieldDisplay
                    label="Last Updated"
                    value={
                        data?.updatedAt
                            ? dayjs(data.updatedAt).format('MMMM D, YYYY [at] HH.mm')
                            : '-'
                    }
                    hasBorder={false}
                />
            </div>
        </div>
    </>
);

export default InfoSection;
